import { actionCobraRefreshToken } from './actions.js';
let scheduledRefreshTimeout = null;
let timeSchedule = 0;
let timeDrift = 0;
export const getServerTime = () => Date.now() + timeDrift;
export const updateTimeDriftByToken = (requestTimestamp, parsedToken) => {
    if (!parsedToken.payload.iat)
        return;
    timeDrift = parsedToken.payload.iat * 1000 - requestTimestamp;
};
export const scheduleRefreshAtTime = (dispatch, time) => {
    if (scheduledRefreshTimeout && time >= timeSchedule)
        return;
    timeSchedule = time;
    const timeout = time - getServerTime();
    console.debug(`[auth] Token refresh after ${timeout / 1000 / 60} minutes`);
    scheduledRefreshTimeout = setTimeout(() => {
        scheduledRefreshTimeout = null;
        dispatch(actionCobraRefreshToken());
    }, Math.max(timeout, 0));
    return;
};
export const unscheduleRefresh = () => {
    if (scheduledRefreshTimeout) {
        clearTimeout(scheduledRefreshTimeout);
        scheduledRefreshTimeout = null;
    }
};
export const scheduleRefreshByToken = (dispatch, parsedToken) => {
    if (!parsedToken?.payload.exp)
        return;
    const now = getServerTime();
    const time = now + (parsedToken.payload.exp * 1000 - now) / 2;
    console.debug(`[auth] scheduleRefreshByToken`, parsedToken);
    scheduleRefreshAtTime(dispatch, time);
};
export const getCurrentRefreshInterval = (exp) => {
    return (exp * 1000 - getServerTime()) / 1000;
};
//# sourceMappingURL=tokenRefreshScheduler.js.map